import React, { Component, useState, useEffect, useRef } from "react";
import Header from "./Header";
import Footer from "./Footer";
import Navbar from "./Navbar";
import AutoNotification from "./AutoNotification";

import ModernLoadingOverlay from '../customComponents/ModernLoadingOverlay';
import { mainStyle, mainColor, header, footer, otherColors } from '../../utility/styles';
import { useSelector, useDispatch } from 'react-redux';
import { allRemoteSettingsSelect, userSelect } from "../../redux/selectors";
import { capitalizeFirstLetter, notify } from "../../utility/Helper1";
import {
    AppBar,
    Toolbar,
    Drawer,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Avatar,
    Typography,
    Box,
    IconButton,
    Backdrop,
    CircularProgress,
    Divider,
    useTheme,
    useMediaQuery,
    Fab
} from '@mui/material';
import {
    Menu as MenuIcon,
    Dashboard,
    AccountBalanceWallet,
    TrendingUp,
    People,
    Security,
    Support,
    Settings,
    Logout,
    Add,
    Remove,
    Description,
    SwapHoriz,
    History,
    Star,
    Telegram,
    WhatsApp,
    AddTaskOutlined,
    Help,
    AttachMoney,
    ShowChart,
    Group,
    Shield,
    AccessibilityNewTwoTone,
    CreditCard,
    AccountBalance,
    Timeline
} from '@mui/icons-material';
import { authActions } from "../../redux/actions";
import { useNavigate } from "react-router-dom";
import { Images } from "../customComponents";
import InvestmentCountdown from "../customComponents/InvestmentCountdown";

function Section(props) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const dispatch = useDispatch();
    const userData = useSelector(userSelect);
    const [sidebarOpen, setSidebarOpen] = useState(!isMobile);
    const [uploadingAvatar, setUploadingAvatar] = useState(false);
    const [selectedTab, setSelectedTab] = useState('dashboard');
    const navigate = useNavigate();
    const hiddenFileInput = useRef(null);
    const site_settings = useSelector(allRemoteSettingsSelect);


    // Sidebar menu items
    const menuItems = [
        { icon: Dashboard, to: '/', name: 'Dashboard', key: 'dashboard' },
        // { icon: AccountBalanceWallet, name: 'Wallet', key: 'wallet' },
        { icon: ShowChart, to: '/new/trade', name: 'Trading', key: 'trading' },
        { icon: CreditCard, to: '/transactions', name: 'Transactions', key: 'transactions' },

        { icon: People, to: '/affiliate-center', name: 'Referrals', key: 'referrals' },
        { icon: Security, to: '/personal-information', name: 'Profile', key: 'security' },
    ];

    const supportItems = [
        { icon: Star, show: true, name: 'Update Bank', action: () => navigate('/bank') },
        { icon: Help, show: true, name: 'Digital Wallet', action: () => navigate('/wallet') },
        { icon: AddTaskOutlined, show: true, name: 'Wallet History', action: () => navigate('/deposit-records') },
        { icon: Telegram, show: site_settings?.site_settings?.telegram, name: 'Telegram', action: () => window.open(site_settings?.site_settings?.telegram_link) },
        { icon: WhatsApp, show: site_settings?.site_settings?.whatsapp, name: 'Customer Service', action: () => window.open(site_settings?.site_settings?.whatsapp) },
        { icon: Help, show: site_settings?.faq?.length > 0, name: 'FAQ', action: () => navigate('/faq') },
        { icon: Description, show: site_settings?.terms != '', name: 'T&C', action: () => navigate('/term') },
    ];

    const progClickFileUpload = () => {
        hiddenFileInput.current?.click();
    };

    const uploadAvatar = async (file) => {
        setUploadingAvatar(true);
        // Simulate upload

        dispatch(authActions.onLogin("account/change-avatar", { avatar: file }, response => {
            setUploadingAvatar(false)
        }),
        )


    };

    const handleLogout = () => {
        dispatch(authActions.onLogout());
        // notify('Logout successful', 1);
    };

    const handleDrawerToggle = () => {
        setSidebarOpen(!sidebarOpen);
    };

    // Custom styling for the sidebar
    const sidebarStyles = {
        background: 'linear-gradient(180deg, rgba(15, 23, 42, 0.95) 0%, rgba(30, 41, 59, 0.95) 100%)',
        backdropFilter: 'blur(20px)',
        borderRight: '1px solid rgba(139, 92, 246, 0.2)',
        '& .MuiListItem-root': {
            margin: '4px 12px',
            borderRadius: '12px',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            '&:hover': {
                background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.1) 0%, rgba(168, 85, 247, 0.1) 100%)',
                transform: 'translateX(4px)',
                boxShadow: '0 8px 25px rgba(139, 92, 246, 0.15)',
            },
            '&.Mui-selected': {
                background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.2) 0%, rgba(168, 85, 247, 0.2) 100%)',
                '&:hover': {
                    background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.3) 0%, rgba(168, 85, 247, 0.3) 100%)',
                }
            }
        },
        '& .MuiListItemIcon-root': {
            color: '#a78bfa',
            minWidth: '40px',
        },
        '& .MuiListItemText-primary': {
            color: '#f8fafc',
            fontWeight: 500,
        }
    };

    useEffect(() => {
        if (!sidebarOpen && !isMobile) {
            setSidebarOpen(true);
        }
    }, [isMobile, sidebarOpen]);

    useEffect(() => {
        if (isMobile) {
            setSidebarOpen(false);
        }
    }, [isMobile]);


    return (
        <Box sx={{
            display: 'flex',
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 25%, #334155 50%, #1e293b 75%, #0f172a 100%)',
            position: 'relative',
            '&::before': {
                content: '""',
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'radial-gradient(ellipse at top left, rgba(139, 92, 246, 0.1) 0%, transparent 50%), radial-gradient(ellipse at bottom right, rgba(168, 85, 247, 0.1) 0%, transparent 50%)',
                pointerEvents: 'none',
                zIndex: 1,
            }
        }}>
            {/* Animated background particles */}
            <Box sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: `
                    radial-gradient(2px 2px at 20px 30px, rgba(139, 92, 246, 0.3), transparent),
                    radial-gradient(2px 2px at 40px 70px, rgba(168, 85, 247, 0.3), transparent),
                    radial-gradient(1px 1px at 90px 40px, rgba(236, 72, 153, 0.3), transparent),
                    radial-gradient(1px 1px at 130px 80px, rgba(59, 130, 246, 0.3), transparent)
                `,
                animation: 'sparkle 4s ease-in-out infinite alternate',
                pointerEvents: 'none',
                zIndex: 1,
                '@keyframes sparkle': {
                    '0%': { opacity: 0.3, transform: 'scale(1)' },
                    '100%': { opacity: 0.8, transform: 'scale(1.1)' }
                }
            }} />

            {/* Top App Bar */}
            <AppBar
                position="fixed"
                sx={{
                    background: 'rgba(15, 23, 42, 0.8)',
                    backdropFilter: 'blur(20px)',
                    borderBottom: '1px solid rgba(139, 92, 246, 0.2)',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
                    zIndex: theme.zIndex.drawer + 1,
                }}
            >
                <Toolbar sx={{ justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>

                        {isMobile && <IconButton
                            edge="start"
                            onClick={handleDrawerToggle}
                            sx={{
                                color: '#a78bfa',
                                '&:hover': {
                                    background: 'rgba(139, 92, 246, 0.1)',
                                    transform: 'scale(1.1)',
                                }
                            }}
                        >
                            <MenuIcon />
                        </IconButton>}

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Box sx={{
                                width: 40,
                                height: 40,
                                borderRadius: 2,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '1.2rem',
                                fontWeight: 'bold',
                                color: 'white',
                            }}>
                                <Images height={20} source={site_settings?.site_settings?.logo} alt="logo" />
                            </Box>

                            {!isMobile || sidebarOpen && <Typography
                                variant="h6"
                                sx={{
                                    background: 'linear-gradient(135deg, #a78bfa 0%, #ec4899 100%)',
                                    backgroundClip: 'text',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    fontWeight: 700,
                                }}
                            >
                                {capitalizeFirstLetter(site_settings?.site_settings?.sitename)}
                            </Typography>}
                        </Box>
                    </Box>

                    {(!isMobile || !sidebarOpen) &&<Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        {/* Investment Countdown Component */}
                        <InvestmentCountdown operationalSettings={site_settings?.operational_settings} />
                        
                        <IconButton
                            sx={{
                                color: '#ef4444',
                                '&:hover': {
                                    background: 'rgba(239, 68, 68, 0.1)',
                                    transform: 'scale(1.1)',
                                },
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            }}
                            onClick={handleLogout}
                            title="Logout"
                        >
                            <Logout />
                        </IconButton>

                        <Box sx={{ display: { xs: 'none', sm: 'block' }, textAlign: 'right', mr: 2 }}>
                            <Typography variant="body1" sx={{ color: '#a78bfa', fontWeight: 600 }}>
                                {capitalizeFirstLetter(userData?.username)}
                            </Typography>
                        </Box>

                        <Box sx={{ position: 'relative' }}>
                            {uploadingAvatar && (
                                <Backdrop open sx={{ position: 'absolute', zIndex: 1, borderRadius: 2 }}>
                                    <CircularProgress size={24} sx={{ color: '#a78bfa' }} />
                                </Backdrop>
                            )}
                            <Avatar
                                onClick={progClickFileUpload}
                                sx={{
                                    width: 44,
                                    height: 44,
                                    cursor: 'pointer',
                                    border: '2px solid transparent',
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    '&:hover': {
                                        transform: 'scale(1.05)',
                                        boxShadow: '0 8px 25px rgba(139, 92, 246, 0.3)',
                                    },
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }}
                                src={userData?.image || undefined}
                            >
                                {!userData?.image && userData?.username?.charAt(0)?.toUpperCase()}
                            </Avatar>
                            <input
                                ref={hiddenFileInput}
                                type="file"
                                accept=".jpg,.gif,.png,.jpeg"
                                onChange={(e) => uploadAvatar(e.target.files[0])}
                                style={{ display: 'none' }}
                            />
                        </Box>
                    </Box>}

                </Toolbar>
            </AppBar>

            {/* Sidebar Drawer starts */}
            <Drawer
                variant={isMobile ? 'temporary' : 'persistent'}
                open={sidebarOpen}
                onClose={handleDrawerToggle}
                sx={{
                    width: 280,
                    '& .MuiDrawer-paper': {
                        width: 280,
                        ...sidebarStyles,
                        mt: '64px',
                        height: 'calc(100vh - 64px)',
                    },
                    zIndex: 2,
                }}
            >
                <Box sx={{ p: 2 }}>

                    <List sx={{ p: 0 }}>
                        {menuItems.map((item) => {
                            const Icon = item.icon;
                            return (
                                <ListItem
                                    style={{ cursor: 'pointer' }}
                                    key={item.key}
                                    button
                                    selected={selectedTab === item.key}
                                    onClick={() => navigate(item.to)}
                                >
                                    <ListItemIcon>
                                        <Icon />
                                    </ListItemIcon>
                                    <ListItemText primary={item.name} />
                                </ListItem>
                            );
                        })}
                    </List>

                    <Divider sx={{ my: 3, borderColor: 'rgba(139, 92, 246, 0.2)' }} />

                    <Typography
                        variant="subtitle2"
                        sx={{
                            color: '#94a3b8',
                            fontWeight: 600,
                            mb: 1,
                            ml: 2,
                        }}
                    >
                        SUPPORT & TOOLS
                    </Typography>

                    <List sx={{ p: 0 }}>
                        {supportItems?.filter(item => item.show)?.map((item, index) => {
                            const Icon = item.icon;
                            return (
                                <ListItem style={{ cursor: 'pointer' }} key={index} button onClick={item.action}>
                                    <ListItemIcon>
                                        <Icon />
                                    </ListItemIcon>
                                    <ListItemText primary={item.name} />
                                </ListItem>
                            );
                        })}
                    </List>
                </Box>
            </Drawer>
            {/* Sidebar Drawer end */}

            {/* Main Content starts*/}
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    p: 3,
                    mt: '64px',
                    transition: theme.transitions.create('width', {
                        easing: theme.transitions.easing.easeOut,
                        duration: theme.transitions.duration.enteringScreen,
                    }),
                    width: !isMobile && sidebarOpen ? 'calc(100% - 280px)' : '100%',
                    position: 'relative',
                    zIndex: 2,
                }}
            >
                {props.children}
            </Box>
            {/* Main Content end*/}

            {/* Floating Action Button */}
            <Fab
                sx={{
                    position: 'fixed',
                    bottom: 24,
                    right: 24,
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    '&:hover': {
                        background: 'linear-gradient(135deg, #5a67d8 0%, #667eea 100%)',
                        transform: 'scale(1.1)',
                        boxShadow: '0 15px 35px rgba(102, 126, 234, 0.4)',
                    },
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    zIndex: 1000,
                }}
                onClick={() => navigate('/new/trade')}
            >
                <Add />
            </Fab>

            <ModernLoadingOverlay
                open={props.loading || false}
                text={props.overlayText || 'Processing your request...'}
                showProgressDots={true}
                size={60}
                thickness={4}
            />
        </Box>
    );

}

export default Section;